export default "__VITE_ASSET__XtwrO0Tx__"